/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@angular-kit/core';
import { ViewModule } from '@angular-kit/view';
import { BsViewModule } from '@angular-kit/bs-view';
import { TimeRecordingModule } from '../time-recording/time-recording.module';

import { TimeClockRoutingModule } from './time-clock-routing.module';
import { TimeClockShellComponent } from './component/time-clock-shell/time-clock-shell.component';
import { TimeClockEmployeeComponent } from './component/time-clock-employee/time-clock-employee.component';
import { TimeClockRegisterComponent } from './component/time-clock-register/time-clock-register.component';
import { TimeClockIdleComponent } from './component/time-clock-idle/time-clock-idle.component';
import { TimeClockInitializer } from './time-clock.initializer';
import { TimeClockService } from './service/time-clock.service';
import { TagInfoResolverService } from './service/tag-info-resolver.service';


@NgModule({
  declarations: [
    TimeClockShellComponent,
    TimeClockIdleComponent,
    TimeClockRegisterComponent,
    TimeClockEmployeeComponent,
  ],
  providers: [
    TimeClockService,
    TagInfoResolverService
  ],
  imports: [
    CommonModule,
    CoreModule,
    ViewModule,
    BsViewModule,
    TimeRecordingModule,
    TimeClockRoutingModule
  ]
})
export class TimeClockModule {

  constructor() {
    TimeClockInitializer.initialize();
  }
}
